import { render, staticRenderFns } from "./activationDetails.vue?vue&type=template&id=f1bb5cec"
import script from "./activationDetails.vue?vue&type=script&lang=js"
export * from "./activationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports